import React from "react";
import WorkIcon from "@mui/icons-material/Work";
import loadable from '@loadable/component'


const ExcelReporting = {
  list: loadable(() => import("./ExcelReportList")),
  create: loadable(() => import("./ExcelReportCreate")),
  edit: loadable(() => import("./ExcelReportEdit")),
  icon: <WorkIcon />,
};

export default ExcelReporting;
